import PropTypes from 'prop-types'
import useContent from 'store/content'
import Input from 'components/Input'

import HalfButtons from './HalfButtons'
import Buttons from './Buttons'
import { StyledList } from './styles'

// needs to validate that there's a list for deleted lists
const List = ({ appId, id }) => {
  const content = useContent()
  const list = content.get.listById(id)

  // items need to be filtered because delete is not well implemented in admin
  // and undefined items can be found in lists
  // ...
  // list.children is an array at first and turns into an object of objects
  // if a style is added to it
  const getItems = () =>
    list &&
    Object.values(list.children)
      .map((item) => (item = content.get.itemById(item.id)))
      .filter((i) => i)

  const displayAs = list && list.style && list.style.displayType

  return list && Object.keys(list.children).length > 0 ? (
    <StyledList>
      {displayAs === 'Button' ? (
        <Buttons items={getItems()} appId={appId} listStyle={list.style || {}} />
      ) : (
        <HalfButtons
          items={getItems()}
          appId={appId}
          listStyle={list.style || {}}
          listItems={list.children}
          overrideChildStyle={list.overrideChildStyle || false}
        />
      )}

      {list.inputIds &&
        list.inputIds.length > 0 &&
        list.inputIds.map((id) => <Input appId={appId} id={id} key={id} />)}
    </StyledList>
  ) : null
}

List.propTypes = {
  appId: PropTypes.string,
  id: PropTypes.string,
}

export default List
